// app/javascript/controllers/collapsible_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'buttonText', 'iconContainer', 'iconUp', 'iconDown']
  static classes = ['expanded']

  connect() {
    console.log('Collapsible controller connected')
    this.updateState()
  }

  toggle(event) {
    console.log('Toggle clicked')
    event.preventDefault()
    event.stopPropagation()

    if (!this.hasContentTarget) {
      console.error('No content target found')
      return
    }

    this.contentTarget.classList.toggle(this.expandedClass)
    this.contentTarget.classList.toggle(
      'max-h-0',
      !this.contentTarget.classList.contains(this.expandedClass)
    )

    this.updateState()
  }

  updateState() {
    if (!this.hasContentTarget) {
      console.error('No content target found in updateState')
      return
    }

    const isExpanded = this.contentTarget.classList.contains(this.expandedClass)
    console.log('Is expanded:', isExpanded)

    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = isExpanded ? 'Esconder Detalhes' : 'Mostrar Detalhes'
    }

    if (this.hasIconUpTarget && this.hasIconDownTarget) {
      this.iconUpTarget.classList.toggle('hidden', !isExpanded)
      this.iconDownTarget.classList.toggle('hidden', isExpanded)
    }
  }
}
